import {
  IMAGE_ACTION,
  IMAGE_MODE,
  IMAGE_MODEL_ID,
  PROVIDER,
} from 'Pods/ThreeDStudio/Store/constants'

// No property defaults: the backend catalog's apply (factor mode, 2x, png). Its rule that
// nulls target_resolution in factor mode (and upscale_factor in target mode) is not
// modelled, as the Edit toolbar sends neither.
export default {
  "model_id": IMAGE_MODEL_ID.FAL_UPSCALE_SEEDVR2,
  "provider": PROVIDER.FAL,
  "action": IMAGE_ACTION.UPSCALE,
  "mode": IMAGE_MODE.SEEDVR2,
  "input_schema": {
    "type": "object",
    "properties": {
      "input_image": {
        "type": "array",
        "minItems": 1,
        "maxItems": 1,
        "items": {
          "type": "object",
          "properties": { "asset_id": { "type": "integer" } },
          "required": ["asset_id"],
        },
      },
      "upscale_mode": {
        "type": "string",
        "enum": ["factor", "target"],
      },
      "upscale_factor": {
        "type": "number",
        "minimum": 1,
        "maximum": 10,
      },
      "target_resolution": {
        "type": "string",
        "enum": ["720p", "1080p", "1440p", "2160p"],
      },
      "noise_scale": {
        "type": "number",
        "minimum": 0,
        "maximum": 1,
      },
      "output_format": {
        "type": "string",
        "enum": ["png", "jpg", "webp"],
      },
      "seed": {
        "type": "integer",
        "minimum": 0,
        "maximum": 2147483647,
      },
    },
    "required": ["input_image"],
  },
  "ui_schema": {},
}
